import React, { useState } from "react";
import PropTypes from "prop-types";
import { setPreview } from "./utils/previewFlag";

export const PageStateContext = React.createContext();
PageStateContext.displayName = "PageContext";

const PageContextProvider = ({ children, initialState }) => {
  const [pageState, setPageState] = useState(initialState);

  React.useEffect(() => {
    setPreview(!!pageState.isPreview);
  }, [pageState.isPreview]);

  const updatePageState = newState => {
    setPageState(prevState => ({ ...prevState, ...newState }));
  };

  return (
    <PageStateContext.Provider value={{ pageState, updatePageState }}>
      {children}
    </PageStateContext.Provider>
  );
};

PageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.object.isRequired,
};

export default PageContextProvider;